module.exports = __webpack_public_path__ + "static/media/stores.2fe99c27.jpg";